import { Address, emptyAddress } from './Address';
import { Dob, emptyDob } from './Dob';

interface Name {
  firstName: string;
  lastName: string;
}

const emptyName: Name = {
  firstName: '',
  lastName: '',
};

export interface ConsumerProfile {
  ssn4?: string;
  ssn9?: string;
  name: Name;
  phone: string;
  email: string;
  address: Address;
  dob: Dob;
}

export const emptyConsumerProfile: ConsumerProfile = {
  name: emptyName,
  phone: '',
  email: '',
  address: emptyAddress,
  dob: emptyDob,
};
